import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('etawah_token');
    const savedUser = localStorage.getItem('etawah_user');
    if (savedToken && savedUser) {
      try {
        setToken(savedToken);
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('etawah_token');
        localStorage.removeItem('etawah_user');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, jwtToken) => {
    setUser(userData);
    setToken(jwtToken);
    localStorage.setItem('etawah_token', jwtToken);
    localStorage.setItem('etawah_user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('etawah_token');
    localStorage.removeItem('etawah_user');
  };

  const getBranchId = () => {
    if (!user) return null;
    if (user.assignedBranches && user.assignedBranches.length > 0) {
      return user.assignedBranches[0].branchId;
    }
    return null;
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout, getBranchId }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
